import {
  filterRtDialogRows,
  matchesRtRowCondition,
  buildRtDialogInfo,
  resolveRtDialogType,
  hasDisplayableRowInfo,
  hasValidLogoImage
} from './rt-dialog-migration'
import { useMedleyLinkResolver } from '@/composables/useMedleyLinkResolver'
import { getAutoRtSession } from '@/composables/useAutoRtSession'
import { loadDefaultJapaneseParser } from 'budoux'
import { emitGlobalVarPopupDialog } from './emitter'
import {
  JOBLIST_KEYWORD_TIERS_DEFAULT,
  JOBLIST_PREFS_DEFAULT,
  isWorkgateConditionRow,
  resolveJoblistKeyword,
  resolveJoblistPref,
  resolveWorkgateOpenArgs
} from '@/utils/rtJoblistFromDialogInfo'
import { isYagibuddyConditionRow } from '@/utils/realtime-transfer/yagibuddyPlaylist'

const globalVar = {
  install: function (Vue, _options) {
    const main = new Vue({
      data: function () {
        return {
          qmailRirekishoHtml: '',
          deviceToken: '',
          dn_flag: 'dn',
          isYagiPrime: false,
          isYagiPrimeCancel: false,
          isYagiPrimeQuickmailcount: 0,
          isShogai: false,
          in_app_payments: true,
          getMessageBoxresult: []
        }
      },
      computed: {},
      methods: {
        // OEM環境チェック
        isOemEnvironment: function () {
          try {
            if (Vue.prototype.$cookies) {
              const oemId = Vue.prototype.$cookies.get('_YAGISH_OEM_ID')
              if (oemId) return true
            }
          } catch (e) {
            console.warn('Cookie access error:', e)
          }
          try {
            if (
              Vue.prototype.$oemContext &&
              !Vue.prototype.$oemContext.isOemEnabled()
            ) {
              return true
            }
          } catch (e) {
            console.warn('oemContext access error:', e)
          }
          return false
        },
        is_BehindRT: function () {
          // ヤマト住建向けの判定
          try {
            const cookies =
              this.$cookies ||
              (typeof Vue !== 'undefined' ? Vue.prototype.$cookies : null)
            if (!cookies) return false

            const flag = cookies.get('_YAGISH_ATHLETE_UNIVID')
            // undefined, nullの判定のため以下の様に返す
            return flag != null
          } catch (error) {
            console.error(error)
            return false
          }
        },
        eventTag: function () {
          // alert('pdf_' + this.dn_flag + '_rt_completed')
          this.invokeNative('pdf_' + this.dn_flag + '_rt_completed')
        },
        invokeNative: function (_id) {
          console.error(_id)
          try {
            window.MessageInvoker?.postMessage(_id)
          } catch (error) {
            console.warn(
              `Error occurred while calling postMessage: ${error.message}`
            )
          }
        },
        keywordCheckFormatOrShokumu: function (targetData, keywordlist) {
          if (!targetData) return false
          return (
            this.keywordCheckRirekisho(targetData, keywordlist) ||
            this.keywordCheckShokumukeirekisho(targetData, keywordlist)
          )
        },
        getMatchedCanonicalSkillList: function (formatData, canonicalSkills) {
          if (!Array.isArray(canonicalSkills) || !formatData) return []
          const list = []
          for (let i = 0; i < canonicalSkills.length; i++) {
            const entry = canonicalSkills[i]
            if (
              entry &&
              Array.isArray(entry.matchForms) &&
              this.keywordCheckFormatOrShokumu(formatData, entry.matchForms)
            ) {
              list.push(entry.canonical)
            }
          }
          // 同一 canonical が複数エントリでマッチした場合の重複を排除
          return list.filter(function (s, i, self) {
            return self.indexOf(s) === i
          })
        },
        keywordCheck: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId === 'shokumukeirekisho') {
            return false
          }
          // 本人希望欄（最も明示的な希望記述）
          if (formatData.request && formatData.request.indexOf(keyword) >= 0) {
            _check = true
          }
          for (const key in formatData.educationalHistories) {
            // 見出し
            const item = formatData.educationalHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.jobHistories) {
            // 見出し
            const item = formatData.jobHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheckOnlyLicense: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId === 'shokumukeirekisho') {
            return false
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck3: function (formatData, keyword) {
          let _check = false

          if (
            formatData.prMessage &&
            formatData.prMessage.indexOf(keyword) >= 0
          ) {
            _check = true
          }
          if (
            formatData.jobSummary &&
            formatData.jobSummary.indexOf(keyword) >= 0
          ) {
            _check = true
          }
          if (formatData.jobHistories) {
            for (const key in formatData.jobHistories) {
              // 見出し
              const item = formatData.jobHistories[key]
              if (
                item &&
                item.businessArea &&
                item.businessArea.indexOf(keyword) >= 0
              ) {
                _check = true
              }
              if (item && item.projects) {
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (
                    subitem &&
                    subitem.contentsOfProject &&
                    subitem.contentsOfProject.indexOf(keyword) >= 0
                  ) {
                    _check = true
                  }
                  if (
                    subitem &&
                    subitem.projectTitle &&
                    subitem.projectTitle.indexOf(keyword) >= 0
                  ) {
                    _check = true
                  }
                  if (
                    subitem &&
                    subitem.position &&
                    subitem.position.indexOf(keyword) >= 0
                  ) {
                    _check = true
                  }
                }
              }
            }
          }
          return _check
        },
        _keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
          }
          // targetData.reasonが存在しない場合はfalseを返す
          if (!targetData.reason || typeof targetData.reason !== 'string') {
            return false
          }
          const parser = loadDefaultJapaneseParser()
          const parsedText = parser.parse(targetData.reason)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
          }
          return false
        },
        /**
         * RT 再表示チェーン（displayPopup4Repeat）用の「特定 KW 該当」判定。
         * keywordCheckRirekisho だけだと本人希望（request）にだけある場合が取りこぼされ、
         * 上限が 2 件のまま（4 件に伸びない）になる。keywordCheck や志望動機（reason）も見る。
         * @param {string} formatId
         * @param {object} [formatData] 履歴書フォーマット Data
         * @param {string[]} keywordlist
         * @param {object} [shokumuFromOther] otherFormatData 内の職務経歴書（マイページ等）
         */
        checkRepeatRTChainExtendedKeywords: function (
          formatId,
          formatData,
          keywordlist,
          shokumuFromOther
        ) {
          if (!keywordlist || !keywordlist.length) return false
          if (formatData) {
            if (this.keywordCheckRirekisho(formatData, keywordlist)) return true
            if (this.keywordCheckShokumukeirekisho(formatData, keywordlist))
              return true
            if (typeof formatData.reason === 'string' && formatData.reason) {
              for (let i = 0; i < keywordlist.length; i++) {
                if (formatData.reason.indexOf(keywordlist[i]) >= 0) return true
              }
            }
          }
          if (
            shokumuFromOther &&
            typeof shokumuFromOther === 'object' &&
            this.keywordCheckShokumukeirekisho(shokumuFromOther, keywordlist)
          ) {
            return true
          }
          if (formatId && formatId !== 'shokumukeirekisho' && formatData) {
            for (let i = 0; i < keywordlist.length; i++) {
              if (this.keywordCheck(formatId, formatData, keywordlist[i]))
                return true
            }
          }
          return false
        },
        LegacyKeywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (
                item.description &&
                item.description.indexOf(keywordlist[keyword]) >= 0
              ) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekishoOnlyLicense: function (
          targetData,
          keyword
        ) {
          if (targetData.skillsToUse) {
            for (const key in targetData.skillsToUse) {
              const item = targetData.skillsToUse[key]
              if (
                item &&
                item.skillname &&
                item.skillname.indexOf(keyword) >= 0
              ) {
                return true
              }
            }
          }
          return false
        },
        _keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (
              targetData.prMessage &&
              targetData.prMessage.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (
              targetData.jobSummary &&
              targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (
                  item &&
                  item.skillname &&
                  item.skillname.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (
                  item &&
                  item.businessArea &&
                  item.businessArea.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (
                    subitem &&
                    subitem.contentsOfProject &&
                    subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.projectTitle &&
                    subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.position &&
                    subitem.position.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                }
              }
            }
          }

          const parser = loadDefaultJapaneseParser()
          const text = [targetData.prMessage || '', targetData.jobSummary || '']
            .join(' ')
            .trim()
          // テキストが空の場合はfalseを返す
          if (!text) {
            return false
          }
          const parsedText = parser.parse(text)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (
              targetData.prMessage &&
              targetData.prMessage.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (
              targetData.jobSummary &&
              targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (
                  item &&
                  item.skillname &&
                  item.skillname.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (
                  item &&
                  item.businessArea &&
                  item.businessArea.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (
                    subitem &&
                    subitem.contentsOfProject &&
                    subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.projectTitle &&
                    subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.position &&
                    subitem.position.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        LegacyKeywordCheckShokumukeirekisho: function (
          targetData,
          keywordlist
        ) {
          for (const keyword in keywordlist) {
            if (
              targetData.prMessage &&
              targetData.prMessage.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (
              targetData.jobSummary &&
              targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0
            ) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (
                  item &&
                  item.skillname &&
                  item.skillname.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (
                  item &&
                  item.businessArea &&
                  item.businessArea.indexOf(keywordlist[keyword]) >= 0
                ) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (
                    subitem &&
                    subitem.contentsOfProject &&
                    subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.projectTitle &&
                    subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                  if (
                    subitem &&
                    subitem.position &&
                    subitem.position.indexOf(keywordlist[keyword]) >= 0
                  ) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        checkJoblistKeyword: function (formatId, formatData) {
          // workgate-condition-row.json（JOBLIST_*_DEFAULT）を単一ソースとする
          return resolveJoblistKeyword({
            formatId,
            formatData,
            tiers: JOBLIST_KEYWORD_TIERS_DEFAULT,
            keywordCheck: (fid, fd, keyword) =>
              this.keywordCheck(fid, fd, keyword),
            keywordCheck3: (fd, keyword) => this.keywordCheck3(fd, keyword)
          })
        },
        getPrefJoblist: function (basicData) {
          return resolveJoblistPref({
            basicData,
            prefs: JOBLIST_PREFS_DEFAULT
          })
        },
        /**
         * workgate 行の additional_dialog_info から keyword/area を組み立てて emit する。
         * @returns {boolean} emit したか
         */
        emitWorkgatePopupFromRow: function (
          row,
          formatId,
          formatData,
          basicData,
          previewFormat,
          opts
        ) {
          if (!isWorkgateConditionRow(row)) return false
          const playlistForce = opts && opts.playlistForce === true
          if (!playlistForce && row.request_able === false) return false
          if (opts && opts.skipWorkgate) return false
          const { keyword, area } = resolveWorkgateOpenArgs(row, {
            formatId,
            formatData,
            basicData,
            keywordCheck: (fid, fd, kw) => this.keywordCheck(fid, fd, kw),
            keywordCheck3: (fd, kw) => this.keywordCheck3(fd, kw)
          })
          emitGlobalVarPopupDialog(
            'open-workgate-popup-dialog',
            formatId,
            previewFormat,
            basicData,
            keyword,
            area
          )
          if (opts && typeof opts.onWorkgateShown === 'function') {
            opts.onWorkgateShown()
          }
          return true
        },
        addressCheck: function (basicData, addresslist) {
          for (const key in addresslist) {
            if (
              basicData.address1 &&
              basicData.address1.indexOf(addresslist[key]) >= 0
            ) {
              return true
            }
          }
          return false
        },
        /**
         * auto_rt と関連 RT1.0 の出し分け。
         * - output 侵入バッチ（rtPlaylistPhase === 'entry'）: 抑止しない（バナーと関連 RT 両方可）
         * - 侵入後: バナー active かつ agreed なら関連 old permission（NewOnly 時は同一 client 全件）を抑止
         * - チェック OFF / セッションなし: 抑止しない
         * @param {object} rd RT 条件行
         * @param {object} [opts] displayFrontEndPopupRenew の opts（rtPlaylistPhase）
         */
        shouldSuppressRtPopupForAutoRT: function (rd, opts) {
          const phase = (opts && opts.rtPlaylistPhase) || 'afterEntry'
          // 侵入バッチ中は関連 RT1.0 も出す
          if (phase === 'entry') return false

          const autoRTInfo = getAutoRtSession().getRelatedAutoRtInfo()
          if (!autoRTInfo || !autoRTInfo.clientId) return false
          // チェック OFF なら関連 RT1.0 を出してよい
          if (autoRTInfo.agreed !== true) return false
          if (rd.client_id !== autoRTInfo.clientId) return false
          const pt = Number(rd.permission_type)
          const oldPt = autoRTInfo.oldPermissionType
          if (oldPt != null && oldPt !== 0) {
            return pt === Number(oldPt)
          }
          // oldPermission を明示していない NewOnly の場合は同一クライアントのポップアップを全て抑制
          return true
        },

        displayFrontEndPopupRenew: function (
          formatId,
          formatData,
          basicData,
          otherFormatData,
          requestData,
          previewFormat,
          isMypage = false,
          opts
        ) {
          if (this.is_BehindRT && this.is_BehindRT()) {
            return false
          }

          if (formatId === 'rirekisho_esf_challenged') {
            return false
          }
          // ① 氏名チェック（どちらかがあればOK）
          const hasName = !!basicData.lastName || !!basicData.firstName

          // ② 電話番号チェック（全ての桁に値があり、数字のみ）
          const tel = [basicData.tel1, basicData.tel2, basicData.tel3].join('')
          const isTelValid =
            basicData.tel1 &&
            basicData.tel2 &&
            basicData.tel3 &&
            /^[0-9０-９]+$/.test(tel)

          // ③ 生年月日チェック（birthYear が4桁）
          const isBirthYearValid = /^[0-9]{4}$/.test(basicData.birthYear)

          if (!hasName || !isTelValid || !isBirthYearValid) return false

          const rtConditionRows = Array.isArray(requestData)
            ? requestData
            : requestData && typeof requestData === 'object'
              ? Object.values(requestData)
              : []
          const rtConditionMap = new Map()
          for (const row of rtConditionRows) {
            if (!row) continue
            const key = `${row.client_id}:${Number(row.permission_type)}`
            // 同一 client_id + permission_type の重複行が混在するため、
            // 1件目固定ではなく「request_able が1件でも true なら表示可」で集約する。
            const current = rtConditionMap.get(key)
            const rowEnabled = row.request_able !== false
            rtConditionMap.set(key, current === true || rowEnabled)
          }
          const isRtConditionEnabled = (clientId, permissionType) => {
            const key = `${clientId}:${Number(permissionType)}`
            const enabled = rtConditionMap.get(key)
            // getDisableRtCondition のレスポンスに行が無い場合は「未制限」とみなす。
            // ここを false 扱いにすると else-if 連鎖で分岐だけ消費され、後続候補(workgate含む)まで進めなくなる。
            return enabled == null ? true : enabled === true
          }
          const playlistForce = opts && opts.playlistForce === true
          const emitRtPopupDialog = (...args) => {
            const permissionType = args[3]
            const dialogInfo = args[4]
            if (!dialogInfo || !dialogInfo.clientId) {
              return false
            }
            // playlist 1件指定時は request_able マップを見ない（循環再表示）
            if (
              !playlistForce &&
              !isRtConditionEnabled(dialogInfo.clientId, permissionType)
            ) {
              return false
            }
            emitGlobalVarPopupDialog(...args)
            return true
          }

          // auto_rt を除いた RT ダイアログ行のコピー（バックエンド配列順を保持）
          const rtDialogRows = filterRtDialogRows(rtConditionRows)
          const isMobileDevice =
            this.$deviceLib.isMobileDevice === true ||
            this.$deviceLib.isMobileDevice === 'SP'

          // 表示判定（条件配列）用コンテキスト。純粋ロジックは rt-dialog-migration.ts に集約。
          const rtConditionContext = {
            formatId,
            formatData,
            basicData,
            isMobileDevice,
            addressCheck: (bd, prefectures) =>
              this.addressCheck(bd, prefectures),
            keywordCheckRirekisho: (fd, keywords) =>
              this.keywordCheckRirekisho(fd, keywords),
            keywordCheckShokumukeirekisho: (fd, keywords) =>
              this.keywordCheckShokumukeirekisho(fd, keywords),
            keywordCheckOnlyLicense: (fid, fd, keyword) =>
              this.keywordCheckOnlyLicense(fid, fd, keyword)
          }

          // Worker 事前フィルタ結果があればそのインデックスのみ走査（順序維持）。無ければ全件。
          const preMatchedIndices =
            opts && Array.isArray(opts.preMatchedIndices)
              ? opts.preMatchedIndices
              : null
          const rowIndices =
            preMatchedIndices != null
              ? preMatchedIndices
              : rtDialogRows.map(function (_row, index) {
                  return index
                })

          // バックエンド配列を順に走査し、移行済みダイアログをレスポンス行の表示情報から組み立てて発火する。
          // workgate 行は RT 共通 emit とは引数が異なるため専用分岐。
          // playlistForce 時は Worker 通過済みの1件を再マッチ / request_able で弾かない。
          // auto_rt 関連抑止はフェーズ＋同意状態依存（entry 中は抑止しない）。
          const tryEmitMigratedRtDialog = () => {
            for (let ii = 0; ii < rowIndices.length; ii++) {
              const row = rtDialogRows[rowIndices[ii]]
              if (!row) continue
              if (!playlistForce && row.request_able === false) continue
              if (isWorkgateConditionRow(row)) {
                if (
                  this.emitWorkgatePopupFromRow(
                    row,
                    formatId,
                    formatData,
                    basicData,
                    previewFormat,
                    opts
                  )
                ) {
                  return true
                }
                continue
              }
              if (this.shouldSuppressRtPopupForAutoRT(row, opts)) continue
              if (!hasDisplayableRowInfo(row)) continue
              if (
                !playlistForce &&
                !matchesRtRowCondition(row, rtConditionContext)
              )
                continue
              const dialogInfo = buildRtDialogInfo(row)
              // output 入場バッチでは DL 未完了のため「ダウンロードが完了しました」タイトルを抑止
              dialogInfo.showDownloadCompletedTitle = !(
                opts && opts.rtPlaylistPhase === 'entry'
              )
              if (Array.isArray(dialogInfo.MedlayLinkKey)) {
                const { resolveMedlayLinkKey } = useMedleyLinkResolver()
                const medlayUrls = resolveMedlayLinkKey({
                  medlayLinkKey: dialogInfo.MedlayLinkKey,
                  isMobile: isMobileDevice,
                  keywordCheckRirekisho: (fd, kws) =>
                    this.keywordCheckRirekisho(fd, kws),
                  keywordCheckShokumukeirekisho: (fd, kws) =>
                    this.keywordCheckShokumukeirekisho(fd, kws),
                  formatData
                })
                if (medlayUrls) {
                  dialogInfo.tabLinkUrl = medlayUrls.tabLinkUrl
                  dialogInfo.tabLinkUrlSp = medlayUrls.tabLinkUrlSp
                }
              }
              if (
                !isYagibuddyConditionRow(row) &&
                dialogInfo.sendApiEndpointKey !== 'sendNewRtSystem' &&
                !hasValidLogoImage(dialogInfo.logoImage)
              )
                continue
              const dialogType = resolveRtDialogType(row)
              const isButtonSizeUp = dialogInfo.ButtonSizeUp === true
              if (
                emitRtPopupDialog(
                  dialogType,
                  formatId,
                  previewFormat,
                  Number(row.permission_type),
                  dialogInfo,
                  basicData,
                  isMypage,
                  isButtonSizeUp
                )
              ) {
                if (
                  dialogInfo.RecurrentValid === true &&
                  Array.isArray(dialogInfo.canonicalSkills)
                ) {
                  dialogInfo.recurrentWords = this.getMatchedCanonicalSkillList(
                    formatData,
                    dialogInfo.canonicalSkills
                  )
                }
                return true
              }
            }
            return false
          }

          if (tryEmitMigratedRtDialog()) {
            // 移行済みダイアログ（jobs919_mail:5 / xmile_mail:28）はバックエンド依存で確定。
            // 以降のレガシー分岐は評価しない。
            // 以下に対応するMultirangeの設定をする必要がある
            // if ((basicData.age >= 25 && basicData.age <= 35) || (basicData.age >= 40 && basicData.age <= 55))
            // リカレントAPIに関しては{"ApiEndpointKey": "sendRecurrent"}様に一般的な呼び出し方に改修する必要がある
            // SKILL_CATEGORY_RULESもadditional_dialog_infoから取る形式に変更
            return true
          }
          // workgate は getDisableRtCondition の行として表示
          return false
        }
      }
    })
    Vue.prototype.$globalVar = main
  }
}
export default globalVar
